import React, { useContext, useEffect, useState } from "react";
import { FluentButton } from "../../../../components/FluentUI/Fluent-Button";
import { FluentBadge } from "../../../../components/FluentUI/Fluent-Badge";
import { FluentTooltip } from "../../../../components/FluentUI/Fluent-Tooltip";
import FluentUiIcon from "../../../../assets/fluent-ui-icon";
import PropTypes from "prop-types";
import { AutoPopulateDialog } from "./autopopulate-dialog";
import { AutoPopulateDialogStatus } from "./autopopulate-dialog-status";
import { GetStatusForImportData } from "../../../../services/api/task-form-api";
import { BadgeConfig } from "./task-form-util";
import { formatDate } from "../../../../util/time-helpers";
import { LoginContext } from "../../../../services/api/authentication-api";

export default function TaskFormHeader({
  values,
  isSubmitting,
  setSubmitting,
  ResetFormSection,
  AutoPopulateSubForm,
  AutoPopulateCount,
  SaveSubForm,
  FormLabel,
  taskId,
  formStatusMap
}) {
  const [dialog2, setDialog2] = useState(false);
  const [dialog3, setDialog3] = useState(false);
  const [status, setStatus] = useState({
    action: null,
    time: null,
  });
  const user = useContext(LoginContext);
  const labels = user?.currentUser?.objectLabels;

  useEffect(() => {
    const fetchData = async () => {
      let result = await GetStatusForImportData(parseInt(taskId));
      let splitResult = result?.data?.split("<>");
      let stateObj = { action: parseInt(splitResult[0]), time: splitResult[1] };
      setStatus(stateObj);
    };
    if (taskId) fetchData();
  }, [taskId]);

  const OnAutoPopulate = (e, isSave = false, isInProgressSave = false) => {
    if (
      status.action === parseInt(Object.keys(BadgeConfig)[0]) &&
      !isInProgressSave
    ) {
      setDialog3(true);
    } else if (
      status.action === parseInt(Object.keys(BadgeConfig)[0]) &&
      isInProgressSave &&
      AutoPopulateCount < 1
    ) {
      setDialog3(false);
      AutoPopulateSubForm(setSubmitting);
    } else if (isSave || AutoPopulateCount < 1) {
      setDialog2(false);
      setDialog3(false);
      AutoPopulateSubForm(setSubmitting);
    } else if (AutoPopulateCount >= 1) {
      setDialog3(false);
      setDialog2(true);
    }
  };

  return (
    <div className="d-flex header justify-content-end">
      {FormLabel === "Investigation Package" && (
        <div className="auto-populate">
          {status.action &&
            (status.action !== parseInt(Object.keys(BadgeConfig)[3]) ? (
              <FluentTooltip
                target={
                  <div className="k-cursor-pointer">
                    <FluentBadge
                      shape="circular"
                      appearance="filled"
                      size="extra-large"
                      color={BadgeConfig[status.action].color}
                      icon={BadgeConfig[status.action].icon}
                      text={BadgeConfig[status.action].text}
                    ></FluentBadge>
                  </div>
                }
                positioning="below"
                withArrow={true}
                text={`${BadgeConfig[status.action].tooltip} ${status.time ? formatDate(status.time) : ""
                  }`}
              />
            ) : (
              <div className="k-cursor-pointer">
                <FluentBadge
                  shape="circular"
                  appearance="filled"
                  size="extra-large"
                  color={BadgeConfig[status.action].color}
                  icon={BadgeConfig[status.action].icon}
                  text={BadgeConfig[status.action].text}
                ></FluentBadge>
              </div>
            ))}
          <FluentButton
            disabled={isSubmitting}
            icon={
              <FluentUiIcon
                name={"FlashAutoRegular"}
                color={isSubmitting ? "#bdbdbd" : "#0F6CBD"}
                size={20}
              />
            }
            text={"Auto-populate"}
            onClick={OnAutoPopulate}
          />
        </div>
      )}
      {formStatusMap?.StatusName && <div className="mr-2">
        <FluentBadge
          shape="rounded"
          appearance="tint"
          size="extra-large"
          text={formStatusMap.StatusName}
          style={{
            backgroundColor: formStatusMap.StatusColorBackground,
            color: formStatusMap.StatusColorFont,
            borderStyle: "none",
            borderWidth: "0.5px",
            borderColor: formStatusMap.StatusColorBorder
          }}
        />
      </div>}
      <div className="header-middle-button">
        <FluentButton
          disabled={isSubmitting}
          icon={
            <FluentUiIcon
              name={"EraserRegular"}
              color={isSubmitting ? "#bdbdbd" : "#0F6CBD"}
              size={20}
            />
          }
          text={"Reset the section"}
          onClick={() => {
            ResetFormSection(setSubmitting, values);
          }}
        />
      </div>
      <FluentButton
        disabled={isSubmitting}
        icon={
          <FluentUiIcon
            name={"SaveRegular"}
            color={isSubmitting ? "#bdbdbd" : "#0F6CBD"}
            size={20}
          />
        }
        text={`Save ${labels?.FormSingular ?? "form"}`}
        onClick={() => SaveSubForm(setSubmitting, values, "FormSave")}
      />
      {dialog2 && (
        <AutoPopulateDialog
          open={dialog2}
          OnCancel={() => setDialog2(false)}
          OnSave={(e) => OnAutoPopulate(e, true, true)}
        ></AutoPopulateDialog>
      )}
      {dialog3 && (
        <AutoPopulateDialogStatus
          open={dialog3}
          OnCancel={() => setDialog3(false)}
          OnSave={(e) => OnAutoPopulate(e, false, true)}
        ></AutoPopulateDialogStatus>
      )}
    </div>
  );
}

TaskFormHeader.propTypes = {
  values: PropTypes.object.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  setSubmitting: PropTypes.func.isRequired,
  ResetFormSection: PropTypes.func.isRequired,
  AutoPopulateSubForm: PropTypes.func,
  AutoPopulateCount: PropTypes.number,
  SaveSubForm: PropTypes.func.isRequired,
  FormLabel: PropTypes.string.isRequired,
  taskId: PropTypes.string.isRequired,
  formStatusMap: PropTypes.object,
};
